import StepWrapper from "@/components/steps/StepWrapper";
import OptionCard from "@/components/ui/OptionCard";
import useQuizStore from "@/store/useQuizStore";

const MultiSelectStep = ({ step }) => {
  const { quizData, toggleSelection } = useQuizStore();
  const selected = quizData[step.field] || [];

  const handleToggle = (value, isExclusive) => {
    toggleSelection(step.field, value, isExclusive);
  };

  return (
    <StepWrapper title={step.title} subtitle={step.subtitle}>
      <div className="flex flex-col gap-2 md:gap-2.5">
        {step.options.map((option) => (
          <OptionCard
            key={option.value}
            type="checkbox"
            label={option.label}
            checked={selected.includes(option.value)}
            onChange={() => handleToggle(option.value, option.exclusive)}
          />
        ))}
      </div>
    </StepWrapper>
  );
};

export default MultiSelectStep;
